// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!./tailwind.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/styles/global.css */

body {
  background-color: #111; /* Dark background */
  color: #eee;
}

.app-container {
  background-color: #222; /* Slightly lighter background */
  color: white;
}

button {
  transition: background-color 0.2s;
}

button:hover {
  filter: brightness(1.2);
}

/* Add this for resizable containers */

.resizable {
  resize: both;
  overflow: auto;
  min-width: 200px;
  min-height: 100px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAAA,0BAA0B;;AAG1B;EACE,sBAAsB,EAAE,oBAAoB;EAC5C,WAAW;AACb;;AAEA;EACE,sBAAsB,EAAE,gCAAgC;EACxD,YAAY;AACd;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;AACzB;;AAEA,sCAAsC;;AACtC;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":["/* src/styles/global.css */\n@import './tailwind.css';\n\nbody {\n  background-color: #111; /* Dark background */\n  color: #eee;\n}\n\n.app-container {\n  background-color: #222; /* Slightly lighter background */\n  color: white;\n}\n\nbutton {\n  transition: background-color 0.2s;\n}\n\nbutton:hover {\n  filter: brightness(1.2);\n}\n\n/* Add this for resizable containers */\n.resizable {\n  resize: both;\n  overflow: auto;\n  min-width: 200px;\n  min-height: 100px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
